import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { reduxForm } from 'redux-form';
import { samplingDistributions } from 'mobx-store';

import {
  getAlpha,
  getTailType,
  getLeftCutoff,
  getRightCutoff
} from 'store/form/samplingDistributions';

import { SAMPLING_DISTRIBUTIONS_FORM } from 'store/form';

import RightPaneComponent from './Component';

const RightPaneContainer = observer(
  class RightPaneContainer extends React.Component {
    static propTypes = {
      leftCutoff: PropTypes.number.isRequired,
      rightCutoff: PropTypes.number.isRequired,
      measurement: PropTypes.string.isRequired,
      testSelection: PropTypes.string.isRequired
    }

    constructor (props) {
      super(props);

      this.handleDotClick = ({ target: { __data__: { id } } }) => {
        samplingDistributions.selectedSampleId = id;
      };
    }

    get tailTypeRadioButtonProps () {
      return {
        getAlpha,

        form: SAMPLING_DISTRIBUTIONS_FORM,

        mean: samplingDistributions.dotsMean,
        stdev: samplingDistributions.dotsStdev
      };
    }

    render () {
      const dots = map(samplingDistributions.dots,
        (value, index) => ({ id: index, value })
      );

      return (
        <RightPaneComponent
          mean={samplingDistributions.dotsMean}
          stdev={samplingDistributions.dotsStdev}
          amount={samplingDistributions.dotsAmount}

          dots={dots}

          parameterName={samplingDistributions.parameter.name}
          selectedSample={samplingDistributions.selectedSampleId}

          tailTypeRadioButtonProps={this.tailTypeRadioButtonProps}

          measurement={this.props.measurement}
          testSelection={this.props.testSelection}

          leftCutoff={this.props.leftCutoff}
          rightCutoff={this.props.rightCutoff}

          onDotClick={this.handleDotClick}
        />
      );
    }
  }
);

const mapStateToProps = state => {
  const tailType = getTailType(state);

  const leftCutoff = getLeftCutoff(state) || -Infinity;
  const rightCutoff = getRightCutoff(state) || +Infinity;

  let measurement = samplingDistributions.parameter.name;
  let testSelection = 'Mean';
  if (samplingDistributions.parameterLevel) {
    measurement = (`(${samplingDistributions.parameter.name} = '${samplingDistributions.parameterLevel}')`);
    testSelection = 'Proportion';
  }

  return {
    leftCutoff: tailType === 'left' || tailType === 'both' ? leftCutoff : -Infinity,
    rightCutoff: tailType === 'right' || tailType === 'both' ? rightCutoff : +Infinity,
    testSelection,
    measurement
  };
};

export default reduxForm({
  form: SAMPLING_DISTRIBUTIONS_FORM, destroyOnUnmount: false
})(connect(mapStateToProps)(RightPaneContainer));
